export default __webpack_public_path__ + "static/media/chat_placeholder.542214d6.png";